/* eslint-disable no-unused-vars */
/**
 * Used for dynamic components in the '@/components/attribute-form-fields' in the forms
 */
class ValidationType {
  type = 'required'
  title = 'Required'
  isValueFieldAvailable = true
  value = ''
  message = 'Обязательное поле'

  constructor (type, title, isValueFieldAvailable = true, message = '') {
    this.type = type
    this.title = title || type
    this.isValueFieldAvailable = isValueFieldAvailable
    if (message) this.message = message
  }
}

const validationTypes = {
  required: new ValidationType('required', 'Обязательное поле', false),
  url: new ValidationType('url', 'URL', false, 'Должно быть URL типа'),
  minLength: new ValidationType('minLength', 'Минимальная длина'),
  maxLength: new ValidationType('maxLength', 'Максимальная длина'),
  startsWith: new ValidationType('startsWith', 'Начинается с..'),
  regex: new ValidationType('regex', 'REGEX')
}

const {
  required,
  url,
  minLength,
  maxLength,
  startsWith,
  regex
} = validationTypes

class AttributeType {
  type = 'STRING'
  availableValidations = []
  constructor (type, availableValidations) {
    this.type = type
    this.availableValidations = availableValidations || Object.values(validationTypes)
  }
}

export default [
  new AttributeType('STRING'),
  new AttributeType('NUMERIC', [required, minLength, maxLength, startsWith, regex]),
  new AttributeType('DATETIME', [required]),
  new AttributeType('BOOLEAN', []),
  new AttributeType('FILE', [required])
]
